<template>
<div :id="'column_'+column.id" @click="test">
<template v-if="column.type=='text'" >
  <template v-if="column.validation_type=='date'">
    <Calendar 
      v-model="inputdata" 
      class="w-full p-inputtext-sm mb-0" 
      :disabled="dropdownNulled"
      :showButtonBar="true"
      @update:modelValue="fieldChanged($event,index,column.type)" 
      dateFormat="dd-mm-yy"
      />
  </template>
  <template v-else>
    <InputText   
    v-model="inputdata"  
    class="w-full p-inputtext-sm mb-0 mt-2"  
    @input="fieldChanged($event,index,column.type)" 
    :disabled="dropdownNulled"
    />
    
  </template>

</template>
<template v-if="column.type=='number'" >
<InputNumber  :min="minval" :max="maxval" v-model="inputdata" mode="decimal" :minFractionDigits="0" :maxFractionDigits="8"    class="w-full p-inputtext-sm mb-0 mt-2"   
@input="fieldChanged($event,index,column.type)" 
:disabled="dropdownNulled"  />
<small  class="p-error pt-2 " v-if="show_message"> {{val_err_message}}</small>
</template>
<template v-if="column.type=='select'" >

<Dropdown v-model="inputdata" 
:options="column.options" 
optionLabel="name" 
optionValue="id" 
class="w-full linebreak_dropdown p-inputtext-sm  mb-0 mt-2"   
@change="fieldChanged($event,index,column.type)" 
:filter="false" 
:emptyMessage="columnTranslation" 
:disabled="dropdownNulled" 
:showClear="true" 
panelClass="linebreak_dropdown">



<template #option="slotProps">
{{getTheTranslation(slotProps.option,"translation")}}   
</template>
</Dropdown>
</template>



</div>
</template>

<script>
import moment from "moment"
export default {

  name: 'ColumnInputItem',
  props:["column","data","index","columnvalue"],
  data () {
    return { 
      inputdata:null,
      intervalobj:null,
      char_length_err_message:null,
      val_err_message:null,
      show_message:false,
    }
  },
  computed:{
    optionvalue()
    {
      if(this.inputdata)
      {
        let option = this.column.options.find(item=> item.id == this.inputdata)
        return this.getTheTranslation(option,"translation")
      }
      return ""
    },
    dropdownNulled()
    {
      if(this.data.submissions.length && this.data.submissions[0].is_nulled)
      {
        return true
      }
      else
      {
        if(this.$store.state.ui.submitting)
        {
          return true
        }
        return false
      }
    },
    columnTranslation()
    {
      return "no items"
    },
    minval()
    {
      
      if(this.column.min_value)
      {
        this.updateMinMaxData()
        return this.column.min_value
      }
      else
      {
        if(this.column.min_value===0)
        {
          return 0
        }
        else
        {
          return -10000000000000000
        }
        
      }
    },
    maxval()
    {
      console.log("maxval")

      if(this.column.max_value)
      {
        this.updateMinMaxData()
        return this.column.max_value
      }
      else
      {
        if(this.column.max_value===0)
        {
          return 10000000000000000
        }
        else
        {
          return 10000000000000000
        }        
      }
    },
  },
  mounted()
  {    
    if(this.column.type=="number")
  	 {

  		if(!isNaN(this.columnvalue))
  		{
  			
  			this.inputdata = parseFloat(this.columnvalue)
  		}
  		if(!this.columnvalue)
  		{
  			 if(this.columnvalue!==0)
            {
              this.inputdata = null
            }
  		}
  		
  	}
  	else
  	{
      if(this.column.validation_type=="date")
      {
        if(this.columnvalue)
        {
          this.inputdata = moment(this.columnvalue).format('DD-MM-YYYY');
        }
        
      }
      else
      {
        this.inputdata = this.columnvalue
      }
  		
  	}
  },
  watch:
  {
  	show_message()
  	{
  		
  	},
  	columnvalue(newval)
  	{
      
  		
  		if(this.column.type=="number")
  		{
  			
  			if(!isNaN(newval))
  			{
  				this.inputdata = parseFloat(newval)
  			}

  			if(!newval )
  			{
          if(newval!==0)
          {
            this.inputdata = null
          }
  				
  			}
  		}
  		else
  		{
        if(this.column.validation_type=="date")
        {
          if(newval)
          {
            this.inputdata = moment(newval).format('DD-MM-YYYY');
          }
          else
          {
            this.inputdata = null
          }
          
        }
        else
        {
          this.inputdata = newval
        }
  			
  		}
  		
  	}
  },
  methods:{
    test()
    {
      console.log(this.column)
      console.log(this.columnvalue)
    },
    updateMinMaxData()
    {
      let column = this.column
      if(column.min_char_length && event.target.value <=column.min_char_length)
        {  
          
          this.val_err_message = this.$store.state.languages.lang_phrases.bu_alan_icin_minimum_karakter_sayisi+column.min_char_length
          this.show_message = true
          //return false
        }
        else if(column.max_char_length && event.target.value >=column.max_char_length)
        {
          
          this.val_err_message = this.$store.state.languages.lang_phrases.bu_alan_icin_maximum_karakter_sayisi+column.max_char_length
          this.show_message = true
          //return false
        }
        else
        {
          this.show_message = false
        }

    },
    getOptionValue(id)
    {
      console.log("getOptionValue")
      console.log(id)
      console.log(this.column.options)
      return "asd"
      let option = this.column.options.find(item=> item.id == id)
      return this.getTheTranslation(option,"translation")
    },
  	fieldChanged(event,index,type)
  	{
      console.log("fieldChanged")
      console.log(event)
      this.$store.dispatch('evaluation/setActiveInputfield',this.data) 
      if(type=="select")
      {

        this.inputdata= event.value
        
        this.$emit("columnFieldSubmitted",{inputdata:this.inputdata,index:this.index})
        return false
      }
      if(type=="text")
      {
        if(this.column.validation_type=="date")
        {
            if(this.inputdata=="null")
            {
              this.inputdata=null
            }
            this.show_message = false
            //this.clearIntervalObject()
            //this.setIntervalObj()
            this.$emit("columnFieldSubmitted",{inputdata:this.inputdata,index:this.index})
            return false
        }

        if(!event.target.value)
        {
            this.inputdata= event.target.value
            this.show_message = false
            //this.clearIntervalObject()
            //this.setIntervalObj()
            this.$emit("columnFieldSubmitted",{inputdata:this.inputdata,index:this.index})
            return false
        }

        let column = this.column
        
        
        if(column.min_char_length && event.target.value <=column.min_char_length)
        {  
          
          this.val_err_message = this.$store.state.languages.lang_phrases.bu_alan_icin_minimum_karakter_sayisi+column.min_char_length
          this.show_message = true
          return false
        }
        else if(column.max_char_length && event.target.value >=column.max_char_length)
        {
          
          this.val_err_message = this.$store.state.languages.lang_phrases.bu_alan_icin_maximum_karakter_sayisi+column.max_char_length
          this.show_message = true
          return false
        }
        else
        {
          this.inputdata= event.target.value
          this.show_message = false
          //this.clearIntervalObject()
          //this.setIntervalObj()
          this.$emit("columnFieldSubmitted",{inputdata:this.inputdata,index:this.index})
          return false
        }


               
      }
      if(type=="number")
      {
        console.log("number")
        console.log(event.value)
        if(!event.value)
        {
            this.inputdata= event.value
            this.show_message = false
            //this.clearIntervalObject()
            //this.setIntervalObj()
            this.$emit("columnFieldSubmitted",{inputdata:this.inputdata,index:this.index})
            return false
        }
        if(!event.value && this.column.is_required===0)
        {
          this.inputdata= event.value
          this.show_message = false
          //this.clearIntervalObject()
          //this.setIntervalObj()
          this.$emit("columnFieldSubmitted",{inputdata:this.inputdata,index:this.index})
          return false
        }
        let column = this.column
        //console.log(column)
        //if min and max set
        if(column.min_value && column.max_value)
        {
          if(event.value>=column.min_value &&  event.value<=column.max_value)
          {
          	this.inputdata= event.value
            this.show_message = false
            //this.clearIntervalObject()
            //this.setIntervalObj()
            this.$emit("columnFieldSubmitted",{inputdata:this.inputdata,index:this.index})
          }
          else if(parseFloat(event.value)<=column.min_value)
          {
            
             this.val_err_message = this.$store.state.languages.lang_phrases.bu_alan_icin_minimum_deger+column.min_value.toLocaleString()
             this.show_message = true
             clearInterval(this.intervalobj);
             
          }
          else if(event.value>column.max_value)
          {
             this.val_err_message = this.$store.state.languages.lang_phrases.bu_alan_icin_maximum_deger+column.max_value.toLocaleString()
             this.show_message = true
             clearInterval(this.intervalobj);
             return false
          }
        }
        //if min and max set
        //if min and max not set
        else
        {

          //if min set max not set
          if(column.min_value && !column.max_value)
          {
            if(event.value<=column.min_value)
            {
               this.val_err_message = this.$store.state.languages.lang_phrases.bu_alan_icin_minimum_deger+column.min_value.toLocaleString()
               this.show_message = true
               clearInterval(this.intervalobj);
               return false
            }
            else
            {
              this.inputdata= event.value
              this.show_message = false
              //this.clearIntervalObject()
              //this.setIntervalObj()
              this.$emit("columnFieldSubmitted",{inputdata:this.inputdata,index:this.index})
            }
          }
          //if min set max not set
          //if max set min not set

          if(!column.min_value && column.max_value)
          {
            if(event.value>column.max_value)
            {
               this.val_err_message = this.$store.state.languages.lang_phrases.bu_alan_icin_maximum_deger+column.max_value.toLocaleString()
               this.show_message = true
               clearInterval(this.intervalobj);
               return false
            }
            else
            {
              this.inputdata= event.value
              this.show_message = false
              //this.clearIntervalObject()
              //this.setIntervalObj()
              this.$emit("columnFieldSubmitted",{inputdata:this.inputdata,index:this.index})
            }
          }
          //if max set min not set
          //if max not set min not set
          if(!column.min_value && !column.max_value)
          {
          	  this.inputdata= event.value
              this.show_message = false
              //this.clearIntervalObject()
              //this.setIntervalObj()
              this.$emit("columnFieldSubmitted",{inputdata:this.inputdata,index:this.index})
          }
          //if max not set min not set





        }
        //if min and max not set




        

      }
  		
  		//this.$emit("columnFieldSubmitted",{inputdata:this.inputdata,index:this.index})
  	},
  	setIntervalObj()
  	{
  		this.intervalobj = setInterval(()=>{
        this.clearIntervalObject()
  			this.$emit("columnFieldSubmitted",{inputdata:this.inputdata,index:this.index})
  			 
  		},2000)
  	},
    clearIntervalObject()
    {
      clearInterval(this.intervalobj);
    },
  },
  
}
</script>

<style lang="css">
  .linebreak_dropdown > div > ul > li{
    max-width: 350px;
    white-space: normal;
  }
</style>